import { jsx as _jsx } from "react/jsx-runtime";
import { createFilterOptions } from "@mui/material/useAutocomplete";
import { Autocomplete } from "./Autocomplete.js";
export const AutocompleteFreeSolo = ({ getOptionLabel, getNewValueOption, ...props }) => {
    const filter = createFilterOptions();
    return (_jsx(Autocomplete, { ...props, freeSolo: true, clearOnBlur: true, selectOnFocus: true, handleHomeEndKeys: true, getOptionLabel: getOptionLabel, filterOptions: (options, params) => {
            const filtered = filter(options, params);
            const isExisting = options.some(role => getOptionLabel(role) === params.inputValue);
            // Suggest the creation of a new value
            if (params.inputValue !== "" && !isExisting) {
                filtered.push(getNewValueOption(params.inputValue));
            }
            return filtered;
        } }));
};
//# sourceMappingURL=AutocompleteFreeSolo.js.map